export type Line = { name: string; num: string; note: string };
export type Country = { code: string; name: string; emergency: string; lines: Line[] };

// Numeri ufficiali controllati a giugno 2026. Il 112 funziona in tutta l'Unione Europea.
export const COUNTRIES: Country[] = [
  { code: "IT", name: "Italia", emergency: "112", lines: [
    { name: "Telefono Amico Italia", num: "02 2327 2327", note: "ascolto" },
    { name: "Samaritans Onlus", num: "06 77208977", note: "ascolto" },
    { name: "Telefono Azzurro", num: "19696", note: "per chi ha meno di 18 anni" },
    { name: "Antiviolenza e stalking", num: "1522", note: "gratuito, 24 ore su 24" },
  ] },
  { code: "FR", name: "Francia", emergency: "112", lines: [
    { name: "Prévention du suicide", num: "3114", note: "gratuito, 24 ore su 24" },
    { name: "SAMU", num: "15", note: "emergenza medica" },
  ] },
  { code: "DE", name: "Germania", emergency: "112", lines: [
    { name: "TelefonSeelsorge", num: "0800 111 0 111", note: "ascolto gratuito, 24 ore su 24" },
    { name: "TelefonSeelsorge", num: "0800 111 0 222", note: "ascolto gratuito, 24 ore su 24" },
    { name: "Nummer gegen Kummer", num: "116 111", note: "per bambini e ragazzi" },
  ] },
  { code: "ES", name: "Spagna", emergency: "112", lines: [
    { name: "Línea 024", num: "024", note: "prevenzione del suicidio, 24 ore su 24" },
  ] },
  { code: "CH", name: "Svizzera", emergency: "112", lines: [
    { name: "La Main Tendue / Die Dargebotene Hand", num: "143", note: "ascolto, 24 ore su 24" },
    { name: "Pro Juventute", num: "147", note: "per bambini e ragazzi" },
    { name: "Ambulanza", num: "144", note: "emergenza medica" },
  ] },
  { code: "AT", name: "Austria", emergency: "112", lines: [
    { name: "TelefonSeelsorge", num: "142", note: "ascolto, 24 ore su 24" },
    { name: "Rat auf Draht", num: "147", note: "per bambini e ragazzi" },
  ] },
  { code: "BE", name: "Belgio", emergency: "112", lines: [
    { name: "Zelfmoordlijn", num: "1813", note: "prevenzione del suicidio (nederlandstalig)" },
    { name: "Centre de Prévention du Suicide", num: "0800 32 123", note: "prevenzione del suicidio (francophone)" },
  ] },
  { code: "NL", name: "Paesi Bassi", emergency: "112", lines: [
    { name: "113 Zelfmoordpreventie", num: "113", note: "anche 0800 0113 gratuito" },
  ] },
  { code: "GR", name: "Grecia", emergency: "112", lines: [
    { name: "Klimaka", num: "1018", note: "prevenzione del suicidio, 24 ore su 24" },
  ] },
  { code: "IE", name: "Irlanda", emergency: "112", lines: [
    { name: "Samaritans", num: "116 123", note: "ascolto gratuito, 24 ore su 24" },
  ] },
  { code: "GB", name: "Regno Unito", emergency: "999", lines: [
    { name: "Samaritans", num: "116 123", note: "ascolto gratuito, 24 ore su 24" },
    { name: "NHS", num: "111", note: "assistenza sanitaria non urgente" },
  ] },
  { code: "PL", name: "Polonia", emergency: "112", lines: [
    { name: "Linea di sostegno", num: "116 123", note: "per adulti in difficoltà emotiva" },
    { name: "Linea per ragazzi", num: "116 111", note: "per bambini e ragazzi" },
  ] },
];

const KEY = "unseen_help_country";
const guess = () => {
  const lang = (navigator.language || "it-IT").toUpperCase();
  const code = lang.split("-")[1] || lang.slice(0, 2);
  return COUNTRIES.find((c) => c.code === code)?.code || "IT";
};
export const getCountry = (): Country => {
  const code = localStorage.getItem(KEY) || guess();
  return COUNTRIES.find((c) => c.code === code) || COUNTRIES[0];
};
export const setCountry = (code: string) => localStorage.setItem(KEY, code);
export const tel = (num: string) => `tel:${num.replace(/[^\d+]/g, "")}`;
